<template>
    <div class="lawlex-custom-card">
      <div class="user-not-registered-wraper">
        <img src="@/img/lawlex_lock.svg"/>
        <div>
          <span v-html="$t(type === 'saved_search' ? 'msg_user_not_registered_saved_search' : type === 'saved_search_us' ? 'msg_user_not_registered_saved_search_us' : 'msg_user_not_registered')"></span><br/><br/>
          <span v-if="type !== 'saved_search' && type !== 'saved_search_us'">{{ $t('msg_user_not_registered_click') }} <a href="javascript:void(0)" class="link" @click="handleClick">{{ $t('msg_user_not_registered_here') }}</a> {{ $t('msg_user_not_registered_register') }}.</span>
        </div>
      </div>
    </div>
  </template>

  <script>
  import { createNamespacedHelpers } from "vuex";
  import { LAWLEXAU, LAWLEXEU, LAWLEXUS } from "../../constant";
  const { mapActions } = createNamespacedHelpers('quickviews');
  export default {
    name: "UserNotRegistered",
    props: {
      type: {
        type: String,
        default: 'regulatory'
      }
    },
    methods: {
    ...mapActions(
      [
        'redirectToUrl'
      ]
    ),
    handleClick() {
      const isSavedSearch = this.type === 'saved_search';
      const isSavedSearchUs = this.type === 'saved_search_us';
      const module = isSavedSearch
        ? 'LawlexEU - UserNotPartOfGroup'
        : isSavedSearchUs
        ? 'LawlexUS - UserNotPartOfGroup'
        : 'LawlexAU - UserNotRegistered';
      const type = isSavedSearch ? LAWLEXEU : isSavedSearchUs ? LAWLEXUS : LAWLEXAU;
      const url = '';
      this.redirectToUrl({ url, module, type });
    }
  }
  };
  </script>
